<div class="err">
  <!-- LOGO -->
  <div class="err__logo">
    <svg viewBox="0 0 512 256">
      <use [attr.xlink:href]="'assets/images/logo.svg#svg1'"></use>
    </svg>
  </div>
  <!-- TITLE -->
  <div class="err__title">
    <ng-container *ngIf="oktaError !== ''">
      <div>Bumped into an error:</div>
      <div class="err__title__desc">{{oktaError}}</div>
      <div class="err__title__button-wrapper">
        <div class="simple-button primary" (click)="oktaTryAgain()">try again</div>
        <div class="simple-button" (click)="contactUs()">contact us</div>
      </div>
    </ng-container>
  </div>
</div>
